<template lang="html">
  <div class="__loading">
    <v-overlay :value="overlay" color="white">
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      />
    </v-overlay>
  </div>
</template>

<script>
import {
  getDataDetailTableItem as getDataDetailTableDinein
} from '@/api/setting'
export default {
  data() {
    return {
      overlay: true,
      url_id: '',
      form: {
        total_guest: 1,
        table: '',
        item: []
      },
      dataInCart: {}
    }
  },
  mounted() {
    this.goToDinein()
  },
  methods: {
    async goToDinein() {
      const LOCAL_DATA_CartDineIn = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_data_cart_DINE-IN')
      if (LOCAL_DATA_CartDineIn) {
        this.dataInCart = JSON.parse(LOCAL_DATA_CartDineIn)
      }
      if (!this.$isEmpty(this.dataInCart)) {
        this.form = { ...this.dataInCart }
      }
      // if (!this.$isEmpty(this.$route.query)) {
      //   this.form.table = this.$route.query.table
      // }
      const tmii_outlet = this.$store.state.store_tmii
      if (tmii_outlet.indexOf(this.$route.params.url_id) === -1) {
        if (!this.$isEmpty(this.$route.params) && this.$route.params.no_table) {
          await this.getTable(this.$route.params.no_table, this.$route.query.table)
          this.form.table = this.$route.params.no_table
        }
      }
      const obj = {
        url_id: this.$route.params.url_id,
        id: this.$route.params.store_id
      }
      this.$store.state.qrmode = true
      await this.$store.dispatch('set_qrmode', true)
      await this.$store.dispatch('disable_table', true)
      await this.$store.dispatch('saveSelectedType', 'DINE-IN')
      await this.$store.dispatch('saveDataCartDineIn', this.form)
      await this.$store.dispatch('fetchOutlet', obj)
      if (tmii_outlet.indexOf(this.$route.params.url_id) !== -1) {
        this.$router.push({ name: 'dinein_menu' }).catch(() => {})
      } else {
        this.$router.push({ name: 'qr_code_camera' }).catch(() => {})
      }
    },
    async getTable(id, name = null) {
      try {
        let params = {}
        if (name) {
          params = {
            table_name: name
          }
        }
        const { data } = await getDataDetailTableDinein(id, params)
        this.$store.state.loading_axios = false
        this.form.table_detail = data.data
      } catch (e) {
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
    }
  }
}
</script>
